(function () {
  var defaults = {
    'fauteuil-personnalisation': { ral: '1015', acrylic: 'KAK' },
    'patere-skoool-personnalisation': { ral: '1023', acrylic: 'VIO' },
    'chaise-haute-70-personnalisation': { ral: '6013', acrylic: 'BEI' },
    'chaise-beaubourg-personnalisation': { ral: '4004', acrylic: 'VER' },
    'chaise-personnalisation': { ral: '5024', acrylic: 'INC' },
    'tabouret-haut-beaubourg-70-personnalisation': { ral: '2004', acrylic: 'FUM' },
    'tabouret-haut-70-personnalisation': { ral: '5024', acrylic: 'ORA' },
    'tabouret-personnalisation': { ral: '3015', acrylic: 'ROU' },
    'tabouret-beaubourg-personnalisation': { ral: '6019', acrylic: 'ROS' }
  };

  var officialCollectionImages = {
    'tabouret-haut-70-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_BLANC_INCOLORE.jpg?v=1773172745',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_NOIR_INCOLORE.jpg?v=1772877664',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_VIOLET_VERT.jpg?v=1773172745',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_AMANDE_ROSE.jpg?v=1773172745',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_JAUNE_VIOLET.jpg?v=1773172745',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_ROSE_CLAIR_ROUGE.jpg?v=1772877664',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_BLEU_CIEL_ORANGE.jpg?v=1773172745',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_ORANGE_POP_FUME.jpg?v=1772877665',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_KAKI_BEIGE.jpg?v=1772877664',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_70_BEIGE_KAKI.jpg?v=1773172745'
    },
    'fauteuil-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_BLANC_INCOLORE.jpg?v=1787241798',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_NOIR_INCOLORE.jpg?v=1787241798',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_VIOLET_VERT.jpg?v=1787241799',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_AMANDE_ROSE.jpg?v=1787241799',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_JAUNE_VIOLET.jpg?v=1787241799',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_ROSE_ROUGE.jpg?v=1787241799',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_BLEU_ORANGE.jpg?v=1787241799',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_ORANGE_POP_FUME.jpg?v=1787241799',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_KAKI_BEIGE.jpg?v=1787241799',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/FAUTEUIL_BEIGE_KAKI.jpg?v=1787241798'
    },
    'tabouret-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BLANC_INCOLORE.jpg?v=1773173719',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_NOIR_INCOLORE.jpg?v=1773173719',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_VIOLET_VERT.jpg?v=1773173719',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_AMANDE_ROSE.jpg?v=1773173719',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_JAUNE_VIOLET.jpg?v=1773173719',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_ROSE_CLAIR_ROUGE.jpg?v=1773173719',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BLEU_CLAIR_ORANGE.jpg?v=1773173719',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_ORANGE_POP_FUME.jpg?v=1773173719',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_KAKI_BEIGE.jpg?v=1773173719',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BEIGE_KAKI.jpg?v=1773173719'
    },
    'tabouret-beaubourg-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_BLANC_INCOLORE.jpg?v=1773173593',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_NOIR_INCOLORE.jpg?v=1773173593',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_VIOLET_VERT.jpg?v=1773173593',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_AMANDE_ROSE.jpg?v=1773173593',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_JAUNE_VIOLET.jpg?v=1773173593',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_ROSE_CLAIR_ROUGE.jpg?v=1773173593',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_BLEU_CIEL_ORANGE.jpg?v=1773173593',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_ORANGE_POP_FUME.jpg?v=1772872021',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_KAKI_BEIGE.jpg?v=1773173593',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_BG_BEIGE_KAKI.jpg?v=1773173593'
    },
    'tabouret-haut-beaubourg-70-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_BLANC_INCOLORE.jpg?v=1774052253',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_NOIR_INCOLORE.jpg?v=1774052253',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_VIOLET_VERT.jpg?v=1774052253',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_AMANDE_ROSE.jpg?v=1774052253',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_JAUNE_VIOLET.jpg?v=1774052253',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_ROSE_CLAIR_ROUGE.jpg?v=1774052253',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_BLEU_CIEL_ORANGE.jpg?v=1774052253',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_ORANGE_POP_FUME.jpg?v=1774052253',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_KAKI_BEIGEI.jpg?v=1774052253',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/TABOURET_HAUT_BG_BEIGE_KAKI.jpg?v=1774052253'
    },
    'chaise-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BLANC_INCOLORE.jpg?v=1773168862',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_NOIR_INCOLORE.jpg?v=1773168862',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_VIOLET_VERT.jpg?v=1773038969',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_AMANDE_ROSE.jpg?v=1773038969',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_JAUNE_VIOLET.jpg?v=1773168862',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_ROSE_CLAIR_ROUGE.jpg?v=1773168862',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BLEU_CIEL_ORANGE.jpg?v=1773168862',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_ORANGE_POP_FUME.jpg?v=1773168862',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_KAKI_BEIGE.jpg?v=1773168862',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BEIGE_KAKI.jpg?v=1773168862'
    },
    'chaise-beaubourg-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_BLANC_INCOLORE.jpg?v=1773173239',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_NOIR_INCOLORE.jpg?v=1773173239',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_VIOLET_VERT.jpg?v=1772873905',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_AMANDE_ROSE.jpg?v=1773173239',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_JAUNE_VIOLET.jpg?v=1773173239',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_ROSE_CLAIR_ROUGE.jpg?v=1773173239',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_BLEU_CIEL_ORANGE.jpg?v=1772873905',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_ORANGE_POP_FUME.jpg?v=1772873905',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_BG_KAKI_BEIGE.jpg?v=1773173239'
    },
    'chaise-haute-70-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_BLANC_INCOLORE.jpg?v=1774052798',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_NOIR_INCOLORE.jpg?v=1774052799',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_VIOLET_VERT.jpg?v=1774052799',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_AMANDE_ROSE.jpg?v=1774052799',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_JAUNE_VIOLET.jpg?v=1774052799',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_ROSE_CLAIR_ROUGE.jpg?v=1774052799',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_BLEU_CIEL_ORANGE.jpg?v=1774052799',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_ORANGE_POP_FUME.jpg?v=1774052799',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/CHAISE_HAUTE_KAKI_BEIGE.jpg?v=1774052799'
    },
    'patere-skoool-personnalisation': {
      '9010-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_BLANC_INCOLORE.jpg?v=1773173659',
      '9005-INC': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_NOIR_INCOLORE.jpg?v=1772798065',
      '4004-VER': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_VIOLET_VERT.jpg?v=1772798065',
      '6019-ROS': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_AMANDE_ROSE.jpg?v=1773173659',
      '1023-VIO': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_JAUNE_VIOLET.jpg?v=1773173659',
      '3015-ROU': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_ROSE_CLAIR_ROUGE.jpg?v=1772798065',
      '5024-ORA': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_BLEU_CIEL_ORANGE.jpg?v=1772798065',
      '2004-FUM': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_ORANGE_POP_FUME.jpg?v=1772798065',
      '6013-BEI': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_KAKI_BEIGE.jpg?v=1772798142',
      '1015-KAK': 'https://cdn.shopify.com/s/files/1/0956/6748/7069/files/PATERE_BEIGE_KAKI.jpg?v=1772798142'
    }
  };

  function selectByData(select, key, value) {
    if (!select) return false;
    var options = Array.prototype.slice.call(select.options);
    var index = options.findIndex(function (option) {
      return option.dataset[key] === value;
    });
    if (index < 0) return false;
    select.selectedIndex = index;
    return true;
  }

  function normalizePublicNames(root) {
    var metal = root.querySelector('[data-lbd-metal]');
    if (!metal) return;
    var options = Array.prototype.slice.call(metal.options);
    var orange2004Index = options.findIndex(function (option) {
      return option.dataset.ral === '2004';
    });
    if (orange2004Index < 0) return;

    var orange2004 = options[orange2004Index];
    orange2004.dataset.name = 'Orange';
    orange2004.textContent = 'Orange - RAL 2004';

    var swatches = root.querySelector('[data-lbd-metal-swatches]');
    var swatch = swatches && swatches.children[orange2004Index];
    if (swatch) {
      swatch.setAttribute('aria-label', 'Orange - RAL 2004');
      swatch.title = 'Orange - RAL 2004';
    }
  }

  function showOfficialCollectionImage(root, handle) {
    var handleImages = officialCollectionImages[handle];
    if (!handleImages) return;
    var metal = root.querySelector('[data-lbd-metal]');
    var acrylic = root.querySelector('[data-lbd-acrylic]');
    if (!metal || !acrylic) return;

    var metalOption = metal.options[metal.selectedIndex];
    var acrylicOption = acrylic.options[acrylic.selectedIndex];
    var pair = metalOption.dataset.ral + '-' + acrylicOption.dataset.code;
    var fileName = handleImages[pair];
    if (!fileName) {
      delete root.dataset.officialCollectionImage;
      return;
    }

    window.setTimeout(function () {
      var renderCanvas = root.querySelector('[data-lbd-render]');
      if (renderCanvas) {
        var officialImage = new Image();
        officialImage.crossOrigin = 'anonymous';
        officialImage.onload = function () {
          var context = renderCanvas.getContext('2d');
          context.clearRect(0, 0, renderCanvas.width, renderCanvas.height);
          context.drawImage(officialImage, 0, 0, renderCanvas.width, renderCanvas.height);
        };
        officialImage.src = fileName;
      }

      var candidates = Array.prototype.slice.call(document.querySelectorAll(
        'img[alt*="Tabouret haut 70 cm"],img[alt*="Tabouret haut personnalisable"],img[alt*="Tabouret personnalisable"],img[alt*="Tabouret Beaubourg"],img[alt*="Tabouret haut Beaubourg"],img[alt*="Fauteuil"],img[alt*="Chaise"],img[alt*="Patère"],img[alt*="Patere"]'
      ));
      candidates.sort(function (a, b) {
        return (b.clientWidth * b.clientHeight) - (a.clientWidth * a.clientHeight);
      });
      var target = candidates[0];
      if (!target) return;
      target.src = fileName;
      target.removeAttribute('srcset');
      var picture = target.closest('picture');
      if (picture) {
        Array.prototype.forEach.call(picture.querySelectorAll('source'), function (source) {
          source.removeAttribute('srcset');
        });
      }
      root.dataset.officialCollectionImage = pair;
    }, 80);
  }

  function applyDefault() {
    var root = document.querySelector('.lbd-configurator');
    if (!root || root.dataset.heroDefaultApplied === 'true') return Boolean(root);

    normalizePublicNames(root);

    var canvas = root.querySelector('[data-lbd-render]');
    var handle = canvas ? canvas.dataset.handle : '';
    var target = defaults[handle];
    if (!target) return true;

    var metal = root.querySelector('[data-lbd-metal]');
    var acrylic = root.querySelector('[data-lbd-acrylic]');
    if (!metal || !acrylic) return false;
    if (root.dataset.officialImageListeners !== 'true') {
      root.dataset.officialImageListeners = 'true';
      metal.addEventListener('change', function () { showOfficialCollectionImage(root, handle); });
      acrylic.addEventListener('change', function () { showOfficialCollectionImage(root, handle); });
    }

    var parameters = new URLSearchParams(window.location.search);
    if (parameters.has('variant') || parameters.has('ral') || parameters.has('plexi')) {
      root.dataset.heroDefaultApplied = 'preserved-explicit-selection';
      showOfficialCollectionImage(root, handle);
      return true;
    }

    if (!selectByData(metal, 'ral', target.ral) || !selectByData(acrylic, 'code', target.acrylic)) {
      root.dataset.heroDefaultError = target.ral + '-' + target.acrylic;
      return true;
    }

    root.dataset.heroDefaultApplied = target.ral + '-' + target.acrylic;
    metal.dispatchEvent(new Event('change', { bubbles: true }));
    acrylic.dispatchEvent(new Event('change', { bubbles: true }));
    showOfficialCollectionImage(root, handle);
    return true;
  }

  var attempts = 0;
  function mount() {
    attempts += 1;
    if (!applyDefault() && attempts < 120) requestAnimationFrame(mount);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', function () {
    attempts = 0;
    requestAnimationFrame(mount);
  });
})();
